import { __assign, __makeTemplateObject, __read } from "tslib";
import React, { useEffect, useState, useRef, useMemo, useCallback, } from 'react';
import styled from 'styled-components';
import { v1 as uuidv1 } from 'uuid';
import { Divider } from '..';
import useDebouncedCallback from '../useDebouncedCallback';
import { DEBOUNCED_TIMEOUT, SortedCountries } from './constants';
import CountryItem from './CountryItem';
import { useScrollableList } from '../internal/useScrollableList/useScrollableList';
import { isValidKeyEvent, filterCountriesBySearchString } from './utils';
import { getFixedSpacing } from '../../theme/Spacing/Spacing';
var SListBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: ", "px;\n  overflow: hidden;\n"], ["\n  padding-top: ", "px;\n  overflow: hidden;\n"])), getFixedSpacing(0.5));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow-x: hidden;\n  max-height: 160px;\n"], ["\n  overflow-x: hidden;\n  max-height: 160px;\n"])));
var CountryList = function (_a) {
    var selectedCountry = _a.selectedCountry, onCountrySelect = _a.onCountrySelect, toggleCountryList = _a.toggleCountryList;
    var itemPrefixId = useMemo(uuidv1, []);
    var selectedCountryId = itemPrefixId + "-" + selectedCountry.countryCode.toLowerCase();
    var _b = __read(useState(undefined), 2), highlightedCountry = _b[0], setHighlightedCountry = _b[1];
    var typingCountrySearchRef = useRef(false);
    var _c = __read(useState(''), 2), searchedCountry = _c[0], setSearchedCountry = _c[1];
    var _d = __read(useDebouncedCallback(function () {
        typingCountrySearchRef.current = false;
    }, DEBOUNCED_TIMEOUT), 1), clearTypingCountrySearchRefDebounce = _d[0];
    var countriesList = useMemo(function () {
        var initialCountriesList = SortedCountries.filter(function (country) { return selectedCountry.name !== country.name; });
        var filteredCountriesBySearchString = filterCountriesBySearchString(searchedCountry, initialCountriesList);
        return filteredCountriesBySearchString.length
            ? filteredCountriesBySearchString
            : initialCountriesList;
    }, [searchedCountry, selectedCountry.name]);
    var listRef = useRef(null);
    var getItemProps = useScrollableList({
        selectedItem: undefined,
        highlightedItem: highlightedCountry,
        items: countriesList,
        onHighlight: setHighlightedCountry,
        onSelect: onCountrySelect,
        onEscape: toggleCountryList,
        scrollContainerRef: listRef,
    }).getItemProps;
    var keydownHandler = useCallback(function (e) {
        e.preventDefault();
        clearTypingCountrySearchRefDebounce();
        if (!isValidKeyEvent(e)) {
            return;
        }
        /**
         * we ignore the leading 0, because that would be for a country phone code search,
         * and our codes don't include the 00, nor +. The + is already invalid (isValidKeyEvent)
         */
        if (typingCountrySearchRef.current) {
            setSearchedCountry(function (prevSearchedCountry) { return prevSearchedCountry + e.key; });
        }
        else if (e.key !== '0') {
            typingCountrySearchRef.current = true;
            setSearchedCountry(e.key);
        }
    }, [clearTypingCountrySearchRefDebounce]);
    useEffect(function () {
        document.addEventListener('keydown', keydownHandler, false);
        return function () {
            document.removeEventListener('keydown', keydownHandler, false);
        };
    }, [keydownHandler]);
    // Selected CountryItem should not have "aria-selected" attribute,
    // because it's not reachable from keyboard
    return (React.createElement(SListBox, { role: "listbox", "aria-activedescendant": selectedCountryId, "aria-label": "Select country phone code" },
        React.createElement(CountryItem, { country: selectedCountry, id: selectedCountryId, selected: true }),
        React.createElement(Divider, null),
        React.createElement(Wrapper, { ref: listRef }, countriesList.map(function (country, index) {
            var props = getItemProps({
                index: index,
                itemProps: {
                    key: country.name,
                    'aria-selected': false,
                    focused: (highlightedCountry === null || highlightedCountry === void 0 ? void 0 : highlightedCountry.name) === country.name,
                    id: uuidv1() + "-" + country.countryCode.toLowerCase(),
                },
            });
            return React.createElement(CountryItem, __assign({}, props, { country: country }));
        }))));
};
export default CountryList;
var templateObject_1, templateObject_2;
//# sourceMappingURL=CountryList.js.map